<template>
	<div class="addpropertyManage">
		<el-form :rules="rules" ref="form" :model="form" :label-width="require('@/config/enum').c_ws4"
			:label-suffix="require('@/config/enum').c_colon">
			<el-card>
				<el-form-item :label="$t('lang.lab_Adminnickname')" prop="idNo" class="formcontent">
					<el-input v-model="form.idNo" disabled maxlength="20" :placeholder="$t('lang.pla_Adminnickname')">
					</el-input>
				</el-form-item>
				<el-form-item :label="$t('lang.lab_typeManage')" prop="type">
					<el-radio-group v-model="form.type">
						<el-radio v-for="(item,index) in typelist" :label="item.id" :key="index">{{item.name}}
						</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item :label="$t('lang.lab_HouseUnit')" v-if="form.type==2">
					<el-button @click="HouseUnit()">{{$t('lang.lab_Houselist')}}</el-button>
				</el-form-item>

				<!-- 员工目标值 -->
				<el-card class="garden">
					<el-collapse>
						<el-form-item :label="$t('lang.lab_targetValue')">
							<el-collapse-item>
								<el-form-item class="targetLabel" label="年份">
									<el-date-picker @change="changeYear()" v-model="form.targetYear" type="year"
										:placeholder="$t('lang.lab_changeYear')">
									</el-date-picker>
								</el-form-item>
								<el-form-item v-show="form.targetYear">
									<el-form-item class="targetLabel" label="1月">
										<el-input @input=targetKeyup1() class="targetMonth" v-model="form.month1"
											:placeholder="$t('lang.lab_targetMonth1')"></el-input>
									</el-form-item>
									<el-form-item class="targetLabel" label="2月">
										<el-input @input=targetKeyup2() class="targetMonth" v-model="form.month2"
											:placeholder="$t('lang.lab_targetMonth2')"></el-input>
									</el-form-item>
									<el-form-item class="targetLabel" label="3月">
										<el-input @input=targetKeyup3() class="targetMonth" v-model="form.month3"
											:placeholder="$t('lang.lab_targetMonth3')"></el-input>
									</el-form-item>
									<el-form-item class="targetLabel" label="4月">
										<el-input @input=targetKeyup4() class="targetMonth" v-model="form.month4"
											:placeholder="$t('lang.lab_targetMonth4')"></el-input>
									</el-form-item>
									<el-form-item class="targetLabel" label="5月">
										<el-input @input=targetKeyup5() class="targetMonth" v-model="form.month5"
											:placeholder="$t('lang.lab_targetMonth5')"></el-input>
									</el-form-item>
									<el-form-item class="targetLabel" label="6月">
										<el-input @input=targetKeyup6() class="targetMonth" v-model="form.month6"
											:placeholder="$t('lang.lab_targetMonth6')"></el-input>
									</el-form-item>
									<el-form-item class="targetLabel" label="7月">
										<el-input @input=targetKeyup7() class="targetMonth" v-model="form.month7"
											:placeholder="$t('lang.lab_targetMonth7')"></el-input>
									</el-form-item>
									<el-form-item class="targetLabel" label="8月">
										<el-input @input=targetKeyup8() class="targetMonth" v-model="form.month8"
											:placeholder="$t('lang.lab_targetMonth8')"></el-input>
									</el-form-item>
									<el-form-item class="targetLabel" label="9月">
										<el-input @input=targetKeyup9() class="targetMonth" v-model="form.month9"
											:placeholder="$t('lang.lab_targetMonth9')"></el-input>
									</el-form-item>
									<el-form-item class="targetLabel" label="10月">
										<el-input @input=targetKeyup10() class="targetMonth" v-model="form.month10"
											:placeholder="$t('lang.lab_targetMonth10')"></el-input>
									</el-form-item>
									<el-form-item class="targetLabel" label="11月">
										<el-input @input=targetKeyup11() class="targetMonth" v-model="form.month11"
											:placeholder="$t('lang.lab_targetMonth11')"></el-input>
									</el-form-item>
									<el-form-item class="targetLabel" label="12月">
										<el-input @input=targetKeyup12() class="targetMonth" v-model="form.month12"
											:placeholder="$t('lang.lab_targetMonth12')"></el-input>
									</el-form-item>
								</el-form-item>
							</el-collapse-item>
						</el-form-item>
					</el-collapse>
				</el-card>
				<br />
				<!-- 员工收费目标值 -->
				<el-card class="garden">
					<el-collapse>
						<el-form-item :label="$t('lang.lab_targetFeeValue')">
							<el-collapse-item>
								<el-form-item class="targetLabel" label="年份">
									<el-date-picker @change="changeFeeYear()" v-model="feeForm.targetYear" type="year"
										:placeholder="$t('lang.lab_changeYear')">
									</el-date-picker>
								</el-form-item>
								<el-form-item v-show="feeForm.targetYear">
									<el-form-item class="targetLabel" label="1月">
										<el-input @input=targetFeeKeyup1() class="targetMonth" v-model="feeForm.month1"
											:placeholder="$t('lang.lab_targetMonth1')"></el-input>
									</el-form-item>
									<el-form-item class="targetLabel" label="2月">
										<el-input @input=targetFeeKeyup2() class="targetMonth" v-model="feeForm.month2"
											:placeholder="$t('lang.lab_targetMonth2')"></el-input>
									</el-form-item>
									<el-form-item class="targetLabel" label="3月">
										<el-input @input=targetFeeKeyup3() class="targetMonth" v-model="feeForm.month3"
											:placeholder="$t('lang.lab_targetMonth3')"></el-input>
									</el-form-item>
									<el-form-item class="targetLabel" label="4月">
										<el-input @input=targetFeeKeyup4() class="targetMonth" v-model="feeForm.month4"
											:placeholder="$t('lang.lab_targetMonth4')"></el-input>
									</el-form-item>
									<el-form-item class="targetLabel" label="5月">
										<el-input @input=targetFeeKeyup5() class="targetMonth" v-model="feeForm.month5"
											:placeholder="$t('lang.lab_targetMonth5')"></el-input>
									</el-form-item>
									<el-form-item class="targetLabel" label="6月">
										<el-input @input=targetFeeKeyup6() class="targetMonth" v-model="feeForm.month6"
											:placeholder="$t('lang.lab_targetMonth6')"></el-input>
									</el-form-item>
									<el-form-item class="targetLabel" label="7月">
										<el-input @input=targetFeeKeyup7() class="targetMonth" v-model="feeForm.month7"
											:placeholder="$t('lang.lab_targetMonth7')"></el-input>
									</el-form-item>
									<el-form-item class="targetLabel" label="8月">
										<el-input @input=targetFeeKeyup8() class="targetMonth" v-model="feeForm.month8"
											:placeholder="$t('lang.lab_targetMonth8')"></el-input>
									</el-form-item>
									<el-form-item class="targetLabel" label="9月">
										<el-input @input=targetFeeKeyup9() class="targetMonth" v-model="feeForm.month9"
											:placeholder="$t('lang.lab_targetMonth9')"></el-input>
									</el-form-item>
									<el-form-item class="targetLabel" label="10月">
										<el-input @input=targetFeeKeyup10() class="targetMonth" v-model="feeForm.month10"
											:placeholder="$t('lang.lab_targetMonth10')"></el-input>
									</el-form-item>
									<el-form-item class="targetLabel" label="11月">
										<el-input @input=targetFeeKeyup11() class="targetMonth" v-model="feeForm.month11"
											:placeholder="$t('lang.lab_targetMonth11')"></el-input>
									</el-form-item>
									<el-form-item class="targetLabel" label="12月">
										<el-input @input=targetFeeKeyup12() class="targetMonth" v-model="feeForm.month12"
											:placeholder="$t('lang.lab_targetMonth12')"></el-input>
									</el-form-item>
								</el-form-item>
							</el-collapse-item>
						</el-form-item>
					</el-collapse>
				</el-card>
				<br />
				<el-button class="btn-first" @click="jump()">{{$t('lang.btn_backpage')}}</el-button>
				<el-button class="detailbtn" type="primary" @click="save('form')">
					{{$t('lang.btn_save')}}
				</el-button>
			</el-card>
		</el-form>
		<el-dialog :visible.sync="show" :close-on-click-modal="false" center top="130px" width="600px" :title="title"
			@closed="handleDialogClosed">
			<el-scrollbar>
				<el-form class="trees" :rules="rules" ref="form" :model="form"
					:label-width="require('@/config/enum').c_ws4" :label-suffix="require('@/config/enum').c_colon">
					<el-tree node-key="unitId" ref="tree" :data="unitlist" show-checkbox :props="defaultProps"
						:default-checked-keys="unitlistcheck"></el-tree>
				</el-form>
			</el-scrollbar>
		</el-dialog>
	</div>
</template>
<script>
	/**
	 *@ClassName:addpropertyManage
	 *@Description:物业人员详情
	 *@author:孙斯维
	 *@Copyright:格众科技
	 *@date:2020-03-17
	 */
	import UploadFile from '../../../components/upload_file.vue'
	import {
		mapGetters
	} from 'vuex'

	export default {
		data() {
			/* var phone = /^1(?:3\d|4[4-9]|5[0-35-9]|6[67]|7[013-8]|8\d|9\d)\d{8}$/
			var isPhone = (rule, value, callback) => {
				if (value === '') {
					callback(
						new Error(
							this.$i18n.t('lang.lab_please_Input') +
							this.$i18n.t('lang.lab_phoneNum')
						)
					)
				} else if (!phone.test(value)) {
					callback(
						new Error(this.$i18n.t('lang.lab_inputDutyPersonPhoneIsTrue'))
					)
				} 
			}
			var validatePass = (rule, value, callback) => {
				if (value === '') {
					callback(
						new Error(
							this.$i18n.t('lang.lab_please_Input') +
							this.$i18n.t('lang.lab_password')
						)
					)
				} else if (value.length < 6 || value.length > 15) {
					callback(
						new Error(
							this.$i18n.t('lang.lab_please_Input') +
							this.$i18n.t('lang.lab_frSixToFifteen')
						)
					)
				} else {
					callback()
				}
			} */
			return {
				gardenIds: [], // 小区id绑定
				defaultProps: {
					children: 'nodes',
					label: 'text'
				},
				title: this.$i18n.t('lang.houseUnittitle'), // 楼号/单元title
				show: false, // 弹框开关
				saveData: '', // 存储json字符串
				unitsaveData: '', // 区域存储json字符串
				isDisabled: 0, // 保存的可点击
				isDisabled1: 0, // 保存的可点击
				isDisabled2: 0, // 保存的可点击
				form: {
					type: '',
					idNo: '',
					gardenIds: [], // 小区id绑定

					targetYear: '', // 目标年份
					month1: 0, // 1月目标值
					month2: 0, // 2月目标值
					month3: 0, // 3月目标值
					month4: 0, // 4月目标值
					month5: 0, // 5月目标值
					month6: 0, // 6月目标值
					month7: 0, // 7月目标值
					month8: 0, // 8月目标值
					month9: 0, // 9月目标值
					month10: 0, // 10月目标值
					month11: 0, // 11月目标值
					month12: 0, // 12月目标值
				},  
				feeForm: {
					targetYear: '', // 目标年份
					month1: 0, // 1月目标值
					month2: 0, // 2月目标值
					month3: 0, // 3月目标值
					month4: 0, // 4月目标值
					month5: 0, // 5月目标值
					month6: 0, // 6月目标值
					month7: 0, // 7月目标值
					month8: 0, // 8月目标值
					month9: 0, // 9月目标值
					month10: 0, // 10月目标值
					month11: 0, // 11月目标值
					month12: 0, // 12月目标值
				},  
				//  查询对象
				rules: {
					gardenIds: [{
						type: 'array',
						required: true,
						message: this.$i18n.t('lang.check_garden'),
						trigger: 'change'
					}],
					type: [{
						required: true,
						message: this.$i18n.t('lang.lab_please_Select') +
						this.$i18n.t('lang.lab_typeManage'),
						trigger: 'change'
					}],
					idNo: [{
						required: true,
						message: this.$i18n.t('lang.lab_please_Input') +
							this.$i18n.t('lang.lab_Adminnickname'),
						trigger: 'blur'
					}],
				}, // 表单验证
				typelist: this.$i18n.t('lang.propertyManage.type'), // 管家身份LIST
				gardenlist: [], // 所有小区
				// stationlist: [], // 岗位list
				backsuccess: 0, // 查询对象返回
				id: '', // 区别新增还是修改
				unitlist: [], // 管辖list
				unit: [], // 管辖选择list
				unitnum: 0, // 管辖num
				unitlistcheck: [], // 选中管辖
				units: [], // 保存用管辖list
				changeunit: [], // 关闭弹窗获取管辖list
			}
		},
		computed: {
			...mapGetters(['gardenId', 'staffId']),
		},
		watch: {
			// 切换小区，重新查询管辖区域，否则只查询一次
			gardenId: {
				handler(newVal, oldVal) {
					this.unitnum = 0
				},
				deep: true,
				immediate: true
			},
			backsuccess() {
				if (this.backsuccess === 1) {
					this.gardens()
				}
			},
			form: {
				handler(newVal, oldVal) {
					for (var j = 0; j < newVal.gardenIds.length - 1; j++) {
						for (var i = 0; i < newVal.gardenIds.length - 1; i++) {
							if (newVal.gardenIds[i] > newVal.gardenIds[i + 1]) {
								var temp = newVal.gardenIds[i]
								newVal.gardenIds[i] = newVal.gardenIds[i + 1]
								newVal.gardenIds[i + 1] = temp
							}
						}
					}
					let tempRule = JSON.stringify(newVal)
					if (tempRule === this.saveData) {
						this.isDisabled = 0
					} else {
						this.isDisabled = 1
					}
				},
				deep: true,
				immediate: true
			},
			changeunit: {
				handler(newVal, oldVal) {
					let tempRule = JSON.stringify(newVal)
					if (tempRule === this.unitsaveData) {
						this.isDisabled = 0
					} else {
						this.isDisabled = 1
					}
				},
				deep: true,
				immediate: true
			},
		},
		components: {
			// eslint-disable-next-line vue/no-unused-components
			'upload-file': UploadFile
		},
		destroyed() {
			window.localStorage.setItem('wyform', JSON.stringify(this.form))
			window.localStorage.setItem('wysaveData', JSON.stringify(this.saveData))
			window.localStorage.setItem('wyunitsaveData', JSON.stringify(this.unitsaveData))
		},
		created() {
			if (window.localStorage.getItem('wyform')) {
				this.gardens()
				this.form = JSON.parse(window.localStorage.getItem('wyform'))
				if (window.localStorage.getItem('wysaveData')) {
					this.saveData = JSON.parse(window.localStorage.getItem('wysaveData'))
				}
				if (window.localStorage.getItem('wyunitsaveData')) {
					this.unitsaveData = JSON.parse(window.localStorage.getItem('wyunitsaveData'))
				}
			} else {
				if (this.$route.query.id) {
					this.id = this.$route.query.id
					// 点击修改按钮查询详情对象
					this.staffs()
				} else {
					this.form.type = 1
					// 点击新增按钮
					this.backsuccess = 1
				}

				this.getHouseUnit()
			}
		},
		methods: {
			changeFeeYear() {
				if (this.id && this.feeForm.targetYear) {
					let date = new Date(this.feeForm.targetYear)
					let year = date.getFullYear()
					let loading = this.$loading()
					this.$get(`/feeStaffTargetByStaffYear`, {
						staffId: this.id,
						targetYear: year,
					}).then(res => {
						loading.close()
						if (res.errCode == 0) {
							this.$set(this.feeForm, 'month1', res.targetAmount1 == 0 ? '' : res.targetAmount1)
							this.$set(this.feeForm, 'month2', res.targetAmount2 == 0 ? '' : res.targetAmount2)
							this.$set(this.feeForm, 'month3', res.targetAmount3 == 0 ? '' : res.targetAmount3)
							this.$set(this.feeForm, 'month4', res.targetAmount4 == 0 ? '' : res.targetAmount4)
							this.$set(this.feeForm, 'month5', res.targetAmount5 == 0 ? '' : res.targetAmount5)
							this.$set(this.feeForm, 'month6', res.targetAmount6 == 0 ? '' : res.targetAmount6)
							this.$set(this.feeForm, 'month7', res.targetAmount7 == 0 ? '' : res.targetAmount7)
							this.$set(this.feeForm, 'month8', res.targetAmount8 == 0 ? '' : res.targetAmount8)
							this.$set(this.feeForm, 'month9', res.targetAmount9 == 0 ? '' : res.targetAmount9)
							this.$set(this.feeForm, 'month10', res.targetAmount10 == 0 ? '' : res.targetAmount10)
							this.$set(this.feeForm, 'month11', res.targetAmount11 == 0 ? '' : res.targetAmount11)
							this.$set(this.feeForm, 'month12', res.targetAmount12 == 0 ? '' : res.targetAmount12)
						}
					}, err => {
						this.$message.error(err)
					})
				} else {
					this.feeForm.month1 = ''
					this.feeForm.month2 = ''
					this.feeForm.month3 = ''
					this.feeForm.month4 = ''
					this.feeForm.month5 = ''
					this.feeForm.month6 = ''
					this.feeForm.month7 = ''
					this.feeForm.month8 = ''
					this.feeForm.month9 = ''
					this.feeForm.month10 = ''
					this.feeForm.month11 = ''
					this.feeForm.month12 = ''
				}
			},
			changeYear() {
				if (this.id && this.form.targetYear) {
					let date = new Date(this.form.targetYear)
					let year = date.getFullYear()
					let loading = this.$loading()
					this.$get(`/sklStaffTargetByStaffYear`, {
						staffId: this.id,
						targetYear: year,
					}).then(res => {
						loading.close()
						if (res.errCode == 0) {
							this.$set(this.form, 'month1', res.targetAmount1 == 0 ? '' : res.targetAmount1)
							this.$set(this.form, 'month2', res.targetAmount2 == 0 ? '' : res.targetAmount2)
							this.$set(this.form, 'month3', res.targetAmount3 == 0 ? '' : res.targetAmount3)
							this.$set(this.form, 'month4', res.targetAmount4 == 0 ? '' : res.targetAmount4)
							this.$set(this.form, 'month5', res.targetAmount5 == 0 ? '' : res.targetAmount5)
							this.$set(this.form, 'month6', res.targetAmount6 == 0 ? '' : res.targetAmount6)
							this.$set(this.form, 'month7', res.targetAmount7 == 0 ? '' : res.targetAmount7)
							this.$set(this.form, 'month8', res.targetAmount8 == 0 ? '' : res.targetAmount8)
							this.$set(this.form, 'month9', res.targetAmount9 == 0 ? '' : res.targetAmount9)
							this.$set(this.form, 'month10', res.targetAmount10 == 0 ? '' : res.targetAmount10)
							this.$set(this.form, 'month11', res.targetAmount11 == 0 ? '' : res.targetAmount11)
							this.$set(this.form, 'month12', res.targetAmount12 == 0 ? '' : res.targetAmount12)
						}
					}, err => {
						this.$message.error(err)
					})
				} else {
					this.form.month1 = ''
					this.form.month2 = ''
					this.form.month3 = ''
					this.form.month4 = ''
					this.form.month5 = ''
					this.form.month6 = ''
					this.form.month7 = ''
					this.form.month8 = ''
					this.form.month9 = ''
					this.form.month10 = ''
					this.form.month11 = ''
					this.form.month12 = ''
				}
			},
			targetFeeKeyup1() {
				// 仅保留数字和"."
				this.feeForm.month1 = this.feeForm.month1.replace(/[^\d]/g, '')
				// 首位是0的话去掉
				if (this.feeForm.month1.indexOf('.') < 0 && this.feeForm.month1 != '') {
					this.feeForm.month1 = parseFloat(this.feeForm.month1)
				}
			},
			targetFeeKeyup2() {
				this.feeForm.month2 = this.feeForm.month2.replace(/[^\d]/g, '')
				if (this.feeForm.month2.indexOf('.') < 0 && this.feeForm.month2 != '') {
					this.feeForm.month2 = parseFloat(this.feeForm.month2)
				}
			},
			targetFeeKeyup3() {
				this.feeForm.month3 = this.feeForm.month3.replace(/[^\d]/g, '')
				if (this.feeForm.month3.indexOf('.') < 0 && this.feeForm.month3 != '') {
					this.feeForm.month3 = parseFloat(this.feeForm.month3)
				}
			},
			targetFeeKeyup4() {
				this.feeForm.month4 = this.feeForm.month4.replace(/[^\d]/g, '')
				if (this.feeForm.month4.indexOf('.') < 0 && this.feeForm.month4 != '') {
					this.feeForm.month4 = parseFloat(this.feeForm.month4)
				}
			},
			targetFeeKeyup5() {
				this.feeForm.month5 = this.feeForm.month5.replace(/[^\d]/g, '')
				if (this.feeForm.month5.indexOf('.') < 0 && this.feeForm.month5 != '') {
					this.feeForm.month5 = parseFloat(this.feeForm.month5)
				}
			},
			targetFeeKeyup6() {
				this.feeForm.month6 = this.feeForm.month6.replace(/[^\d]/g, '')
				if (this.feeForm.month6.indexOf('.') < 0 && this.feeForm.month6 != '') {
					this.feeForm.month6 = parseFloat(this.feeForm.month6)
				}
			},
			targetFeeKeyup7() {
				this.feeForm.month7 = this.feeForm.month7.replace(/[^\d]/g, '')
				if (this.feeForm.month7.indexOf('.') < 0 && this.feeForm.month7 != '') {
					this.feeForm.month7 = parseFloat(this.feeForm.month7)
				}
			},
			targetFeeKeyup8() {
				this.feeForm.month8 = this.feeForm.month8.replace(/[^\d]/g, '')
				if (this.feeForm.month8.indexOf('.') < 0 && this.feeForm.month8 != '') {
					this.feeForm.month8 = parseFloat(this.feeForm.month8)
				}
			},
			targetFeeKeyup9() {
				this.feeForm.month9 = this.feeForm.month9.replace(/[^\d]/g, '')
				if (this.feeForm.month9.indexOf('.') < 0 && this.feeForm.month9 != '') {
					this.feeForm.month9 = parseFloat(this.feeForm.month9)
				}
			},
			targetFeeKeyup10() {
				this.feeForm.month10 = this.feeForm.month10.replace(/[^\d]/g, '')
				if (this.feeForm.month10.indexOf('.') < 0 && this.feeForm.month10 != '') {
					this.feeForm.month10 = parseFloat(this.feeForm.month10)
				}
			},
			targetFeeKeyup11() {
				this.feeForm.month11 = this.feeForm.month11.replace(/[^\d]/g, '')
				if (this.feeForm.month11.indexOf('.') < 0 && this.feeForm.month11 != '') {
					this.feeForm.month11 = parseFloat(this.feeForm.month11)
				}
			},
			targetFeeKeyup12() {
				this.feeForm.month12 = this.feeForm.month12.replace(/[^\d]/g, '')
				if (this.feeForm.month12.indexOf('.') < 0 && this.feeForm.month12 != '') {
					this.feeForm.month12 = parseFloat(this.feeForm.month12)
				}
			},
			targetKeyup1() {
				// 仅保留数字和"."
				this.form.month1 = this.form.month1.replace(/[^\d]/g, '')
				// 首位是0的话去掉
				if (this.form.month1.indexOf('.') < 0 && this.form.month1 != '') {
					this.form.month1 = parseFloat(this.form.month1)
				}
			},
			targetKeyup2() {
				this.form.month2 = this.form.month2.replace(/[^\d]/g, '')
				if (this.form.month2.indexOf('.') < 0 && this.form.month2 != '') {
					this.form.month2 = parseFloat(this.form.month2)
				}
			},
			targetKeyup3() {
				this.form.month3 = this.form.month3.replace(/[^\d]/g, '')
				if (this.form.month3.indexOf('.') < 0 && this.form.month3 != '') {
					this.form.month3 = parseFloat(this.form.month3)
				}
			},
			targetKeyup4() {
				this.form.month4 = this.form.month4.replace(/[^\d]/g, '')
				if (this.form.month4.indexOf('.') < 0 && this.form.month4 != '') {
					this.form.month4 = parseFloat(this.form.month4)
				}
			},
			targetKeyup5() {
				this.form.month5 = this.form.month5.replace(/[^\d]/g, '')
				if (this.form.month5.indexOf('.') < 0 && this.form.month5 != '') {
					this.form.month5 = parseFloat(this.form.month5)
				}
			},
			targetKeyup6() {
				this.form.month6 = this.form.month6.replace(/[^\d]/g, '')
				if (this.form.month6.indexOf('.') < 0 && this.form.month6 != '') {
					this.form.month6 = parseFloat(this.form.month6)
				}
			},
			targetKeyup7() {
				this.form.month7 = this.form.month7.replace(/[^\d]/g, '')
				if (this.form.month7.indexOf('.') < 0 && this.form.month7 != '') {
					this.form.month7 = parseFloat(this.form.month7)
				}
			},
			targetKeyup8() {
				this.form.month8 = this.form.month8.replace(/[^\d]/g, '')
				if (this.form.month8.indexOf('.') < 0 && this.form.month8 != '') {
					this.form.month8 = parseFloat(this.form.month8)
				}
			},
			targetKeyup9() {
				this.form.month9 = this.form.month9.replace(/[^\d]/g, '')
				if (this.form.month9.indexOf('.') < 0 && this.form.month9 != '') {
					this.form.month9 = parseFloat(this.form.month9)
				}
			},
			targetKeyup10() {
				this.form.month10 = this.form.month10.replace(/[^\d]/g, '')
				if (this.form.month10.indexOf('.') < 0 && this.form.month10 != '') {
					this.form.month10 = parseFloat(this.form.month10)
				}
			},
			targetKeyup11() {
				this.form.month11 = this.form.month11.replace(/[^\d]/g, '')
				if (this.form.month11.indexOf('.') < 0 && this.form.month11 != '') {
					this.form.month11 = parseFloat(this.form.month11)
				}
			},
			targetKeyup12() {
				this.form.month12 = this.form.month12.replace(/[^\d]/g, '')
				if (this.form.month12.indexOf('.') < 0 && this.form.month12 != '') {
					this.form.month12 = parseFloat(this.form.month12)
				}
			},

			// 监听关闭dialog
			handleDialogClosed() {
				this.units = []
				this.changeunit = []
				this.unit = this.$refs.tree.getCheckedNodes()
				for (var i = 0; i < this.unit.length; i++) {
					if (this.unit[i].nodes) {} else {
						this.units.push(this.unit[i])
					}
				}
				for (var j = 0; j < this.units.length; j++) {
					this.changeunit.push(this.units[j].unitId)
				}
			},
			// 管辖列表
			HouseUnit() {
				this.getHouseUnit()
				this.show = true
			},
			// 管辖list
			getHouseUnit() {
				let id = this.id
				if (id === '') {
					id = 0
				}
				if (this.unitnum === 0) {
					let loading = this.$loading()
					this.$get(
						`/getHouseUnit?parentId=${this.gardenId}&staffId=${id}&operateFlag=true`
					).then(
						res => {
							loading.close()
							if (res && res.errCode === 0) {
								this.unitnum++
								this.unitlist = res.list
								for (var i = 0; i < this.unitlist.length; i++) {
									if (this.unitlist[i].state.disabled === true) {
										this.unitlist[i].disabled = true
									}
									if (
										this.unitlist[i].nodes &&
										this.unitlist[i].nodes.length > 0
									) {
										for (var j = 0; j < this.unitlist[i].nodes.length; j++) {
											if (this.unitlist[i].nodes[j].state.disabled === true) {
												this.unitlist[i].nodes[j].disabled = true
											}
											if (this.unitlist[i].nodes[j].state.checked === true) {
												this.unitlistcheck.push(this.unitlist[i].nodes[j].unitId)
											}
										}
									}
								}
								this.unitsaveData = JSON.stringify(this.unitlistcheck)
							}
						},
						error => {
							loading.close()
							this.$message.error(error)
						}
					)
				}
			},
			// 返回list页面
			jump() {
				this.$router.push({
					name: 'housekeepingArea'
				})
			},

			// 数组排序用
			sequence(a, b) {
				return a - b
			},
			// 编辑查询详情
			staffs() {
				let loading = this.$loading()
				this.$get(
					`/staffs/${this.id}?currentGarden=${this.$store.getters.gardenId}`
				).then(
					res => {
						loading.close()
						if (res && res.errCode === 0) {
							this.form = res
							for (var i = 0; i < this.form.gardenIds.length; i++) {
								if (this.form.gardenIds[i] != null) {
									this.gardenIds.push(parseInt(this.form.gardenIds[i]))
								}
							}
							this.form.gardenIds = this.gardenIds.sort(this.sequence)
							this.saveData = JSON.stringify(this.form)
							this.backsuccess = 1
						}
					},
					error => {
						loading.close()
						this.$message.error(error)
					}
				)
			},

			// 保存
			save(formName) {
				this.$refs[formName].validate(valid => {
					if (valid) {
						if (this.units && this.units.length > 0) {
							for (var s = 0; s < this.units.length; s++) {
								this.units[s].state.checked = true
								this.units[s].state.expanded = false
								this.units[s].state.selected = false
								this.units[s].parentId = this.gardenId
							}
						}
						let params = {
							id: this.id,
							type: this.form.type,
							idNo: this.form.idNo,
							gardenIds: this.form.gardenIds.toString(), // 小区id
							gardenId: this.gardenId,
							unit: this.units.length > 0 ? JSON.stringify(this.units) : '',
							operPeople: this.staffId
						}
						if (this.form.type === 2) {
							if (this.unitlist.length === 0 || this.changeunit.length === 0) {
								this.$message.error(this.$i18n.t('请选择管辖区域'))
								return
							}
						}
						let loading = this.$loading()
						this.$patch(`/updateStaffJurisdiction/${this.id}`, params).then(
							res => {
								loading.close()
								if (res && res.errCode === 0) {
									this.$message.success(
										this.$i18n.t('lang.lab_modify_success')
									)
									var index = this.$keepAlive.indexOf('/manage/main.staff')
									if (index > -1) {
										this.$keepAlive.splice(index, 1)
									}
									this.$router.push({
										name: 'housekeepingArea'
									})
									
									if (this.form.targetYear != undefined) {
										/* 员工目标值 */
										let date = new Date(this.form.targetYear)
										let year = date.getFullYear()
										this.$post(`/sklStaffTarget`, {
											staffId: this.id,
											targetYear: year,
											targetAmount1: this.form.month1 == '' ? 0 : this.form
												.month1,
											targetAmount2: this.form.month2 == '' ? 0 : this.form
												.month2,
											targetAmount3: this.form.month3 == '' ? 0 : this.form
												.month3,
											targetAmount4: this.form.month4 == '' ? 0 : this.form
												.month4,
											targetAmount5: this.form.month5 == '' ? 0 : this.form
												.month5,
											targetAmount6: this.form.month6 == '' ? 0 : this.form
												.month6,
											targetAmount7: this.form.month7 == '' ? 0 : this.form
												.month7,
											targetAmount8: this.form.month8 == '' ? 0 : this.form
												.month8,
											targetAmount9: this.form.month9 == '' ? 0 : this.form
												.month9,
											targetAmount10: this.form.month10 == '' ? 0 : this.form
												.month10,
											targetAmount11: this.form.month11 == '' ? 0 : this.form
												.month11,
											targetAmount12: this.form.month12 == '' ? 0 : this.form
												.month12,
										}).then(res => {
											console.log('目标值提交成功')
										}, err => {
											this.$message.error(err)
										})
									}
									
									if (this.feeForm.targetYear != undefined) {
										/* 员工收费目标值 */
										let date = new Date(this.feeForm.targetYear)
										let year = date.getFullYear()
										this.$post(`/feeStaffTarget`, {
											staffId: this.id,
											targetYear: year,
											targetAmount1: this.feeForm.month1 == '' ? 0 : this.feeForm
												.month1,
											targetAmount2: this.feeForm.month2 == '' ? 0 : this.feeForm
												.month2,
											targetAmount3: this.feeForm.month3 == '' ? 0 : this.feeForm
												.month3,
											targetAmount4: this.feeForm.month4 == '' ? 0 : this.feeForm
												.month4,
											targetAmount5: this.feeForm.month5 == '' ? 0 : this.feeForm
												.month5,
											targetAmount6: this.feeForm.month6 == '' ? 0 : this.feeForm
												.month6,
											targetAmount7: this.feeForm.month7 == '' ? 0 : this.feeForm
												.month7,
											targetAmount8: this.feeForm.month8 == '' ? 0 : this.feeForm
												.month8,
											targetAmount9: this.feeForm.month9 == '' ? 0 : this.feeForm
												.month9,
											targetAmount10: this.feeForm.month10 == '' ? 0 : this.feeForm
												.month10,
											targetAmount11: this.feeForm.month11 == '' ? 0 : this.feeForm
												.month11,
											targetAmount12: this.feeForm.month12 == '' ? 0 : this.feeForm
												.month12,
										}).then(res => {
											console.log('目标值提交成功')
										}, err => {
											this.$message.error(err)
										})
									}
								}
								
							},
							error => {
								loading.close()
								this.$message.error(error)
							}
						)
					}
				})
			},
			// 小区下拉
			gardens() {
				let loading = this.$loading()
				this.$get(`/gardens`).then(
					res => {
						loading.close()
						if (res && res.errCode === 0) {
							this.gardenlist = res.list
						}
					},
					error => {
						loading.close()
						this.$message.error(error)
					}
				)
			},
		}
	}
</script>

<style lang="scss">
	.addpropertyManage .formcontent {
		width: 60vw !important;
	}
	.garden .targetMonth {
		width: 200px;
	}
	
	.targetLabel {
		margin: 10px;
		display: inline-block;
	}
</style>
